<script setup lang="ts">
import { onMounted } from "vue";

const props = defineProps<{ src: string }>();

const generateId = (prefix = "script") => {
  // Prefer the platform crypto.randomUUID when available (modern browsers).
  // Use a safe fallback for older environments or tests.
  const uuid = crypto?.randomUUID?.();

  return uuid
    ? `${prefix}-${uuid}`
    : `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
};

const id = generateId();

onMounted(() => {
  // Inject the TrustIndex loader script once on the client.
  const s = document.createElement("script");
  s.src = props.src;
  s.defer = true;
  s.async = true;
  s.onerror = function (e) {
    console.warn(e);
  };
  document.getElementById(id)?.appendChild(s);
});
</script>

<template>
  <div :id="id"></div>
</template>
